import React, { useEffect, useState } from "react";

import { ModalForm, Button } from "../../../../components";
import { getPriceStr } from "../../../../lib/utils";
import { useDispatch } from "react-redux";
import { addCartItem } from "../../../../redux/cart";
// import { ReactComponent as Smile } from '../../../../assets/icons/Smile.svg'
import { Text, BestNewHot, Price, ChangeQty } from "./compos";
import { ItemOptionInfo } from "./ItemOptionInfo";
import { getItemName } from "../../../../lib-pos";

import { createItemObj2 } from "./createItemObj-testOrder";
import { createCartObj } from "./createCartObj";
// import { notifyOrderToStore, goToPayKis } from "../../../../lib/pay-api-lib";
import { sendOrder } from "../../../../lib-pos/sendOrder";
// import { saveOrderDataBeforePay } from "../../../../lib-pos/saveOrderDataBeforePay";
// import { debug } from "../../../../settings";

export function DetailModal(props) {
  const {
    shopInfo,
    item, itemList,
    itemOptions2,
    isVisible,
    setIsVisible,
  } = props

  const dispatch = useDispatch()

  const title = `주문 테스트`;

  const [isLoading, setIsLoading] = useState(false)
  const [btnText, setBtnText] = useState("주문")
  const [amount, setAmount] = useState(item.price)
  const [clickEnabled, setClickEnabled] = useState(false)
  const [itemCount2, setItemCount2] = useState(1)
  const [selectedOptions, setSelectedOptions] = useState([])
  // const [tableNo, setTableNo] = useState("6")

  const [comments, setComments] = useState("")

  useEffect(() => {
    if (!item.itemName) return // 초기 값이 {} 일 경우 제외
    if (shopInfo.posName === "UNIONPOS") initSelectedOptionsUnionpos()
    if (shopInfo.posName === "OASIS_POS") initSelectedOptionsOasispos()
    if (shopInfo.posName === "EASY_POS") initSelectedOptionsEasypos()
    if (shopInfo.posName === "DUMMY_POS" || shopInfo.posName === "ONL_POS") initSelectedOptionsDpos()
    if (shopInfo.posName === "OKPOS") alert("OKPOS NOT SUPPORTED")
  }, [props.selectedItem])

  /**
   * @TODO shopInfo에 storeCode=shopNo, masterDataKey, headOfficeNo
   */
  const initSelectedOptionsEasypos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })
        console.log('_selectedOptions', _selectedOptions)
        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  const initSelectedOptionsUnionpos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })
        console.log('_selectedOptions', _selectedOptions)
        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  const initSelectedOptionsOasispos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })
        // console.log('_selectedOptions', _selectedOptions)
        // console.table(_selectedOptions)
        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  const initSelectedOptionsDpos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })
        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  // 
  // option 메뉴 변경시 invoke
  // 
  useEffect(() => {
    let orderReady = true
    let sum = parseInt(item.price)
    selectedOptions.map((cls) => {
      if (cls.required) orderReady = orderReady && cls.optionItems.length > 0
      cls.optionItems.map((optItem) => {
        sum += optItem.optPrice
      })
    })

    setClickEnabled(orderReady)
    setAmount(sum * itemCount2)
    setBtnText(`주문 (${getPriceStr(sum * itemCount2)} 원)`)

  }, [selectedOptions, itemCount2])

  const onSubmit = async () => {
    try {
      setIsLoading(true)

      // console.log('item', item)
      console.log('selectedOptions', selectedOptions)

      const cartItem = createCartObj({
        shopInfo,
        item,
        itemList,
        itemOptions2,
        selectedOptions,
        itemCount: itemCount2,
      })
      if (cartItem.err) throw Error(cartItem.err.message)

      console.log('cartItem', cartItem)

      if (props.mode === "ONL_POS") {
        let res = await requestOrderOnlPos(cartItem)
        if (res.err) throw Error(res.err.message)
        return {}
      } else {
        dispatch(addCartItem({ item: cartItem }))
      }
    } catch (e) {
      alert(e.message);
    } finally {
      setIsLoading(false);
      setIsVisible(false);
    }
  };

  const requestOrderOnlPos = async (cartItem) => {
    try {
      const cartItems = [cartItem]
      console.log('cartItems', cartItems)
      // let res = await sendOrder({
      //   shopInfo: props.shopInfo,
      //   cartItems: props.cartItems,
      //   itemOptions2: props.itemOptions2,
      //   tableNo,
      //   token: "1234",
      //   ver: "v3",
      // })
      // if (res.err) throw Error(res.err.message)

      // const orderId = res.result.saveOrder?.orderId

      // console.log('orderId', orderId)

      // if (
      //   props.shopInfo.orderNotifyOptions?.toShop ||
      //   props.shopInfo.posName === "DUMMY_POS"
      // ) {
      //   const resNoti = await notifyOrderToStore({
      //     shopId: props.shopInfo.shopId,
      //     orderId,
      //     phone_number: '01053174673',
      //   })
      //   if (resNoti.err) throw Error(resNoti.err.message)
      // }

      return {}
    } catch (e) {
      // console.log(e)
      return { err: { message: e.message } }
    }

  }

  const styles = {
    wrap: {
      display: 'flex',
      flexDirection: props.isMobilePhone ? "column" : "row",
      justifyContent: 'space-between',
      minHeight: "50vh",
      padding: "0px 5px 15px"
    },
    imgWrap: {
      marginTop: 15,
      width: props.isMobilePhone ? "100%" : "20vw",
      paddingRight: props.isMobilePhone ? 0 : 15,
      display: 'flex', flexDirection: "column",
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    infoWrap: {
      width: props.isMobilePhone ? "100%" : '30vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    sum: {
      marginTop: 15,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }

  return (
    <ModalForm
      visible={isVisible}
      setIsVisible={setIsVisible}
      title={title}
      size={props.mode === "ONL_POS" ? "md" : "lg"}
    >
      <div style={styles.wrap}>
        <div style={styles.infoWrap}>
          <ItemInfo {...props} item={item} />
          <ItemOptionInfo
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
          />
          <div style={styles.sum}>
            <Price
              price={amount}
              style={{ width: '50%' }}
              size="lg"
            />
            <ChangeQty itemCount={itemCount2} setItemCount={setItemCount2} size="lg" />
          </div>
        </div>
      </div>

      <Button
        size="sm"
        variant="primary"
        width="100%"
        title={btnText}
        onClick={onSubmit}
        isLoading={isLoading}
        disabled={!clickEnabled}
      />
    </ModalForm>
  )
}

function ItemInfo(props) {
  const { item } = props

  const [itemName, setItemName] = useState("")

  useEffect(() => {
    const _itemName = getItemName({
      ...props,
      item,
      selectedLanguage: "KR",
      usePosMenuFirst: false,
    })
    console.log(_itemName)
    setItemName(_itemName)
  }, [item])

  const styles = {
    wrap: {
      // marginTop: 15,
      // marginBottom: 15,
    },
    title: { margin: '0px 0px 5px' },
    desc: { marginBottom: 5, color: '#666' },
  }

  return (
    <div style={styles.wrap}>
      <BestNewHot item={item} />
      <Text value={itemName} isTitle />
      <Price price={item.price} />
      <Text style={styles.desc} value={item.description} />
    </div>
  )
}
